






































import Vue from 'vue'
export default Vue.extend({
  name: 'PaintOptions',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    prefix: {
      type: String,
      default: 'options'
    },
    inputType: {
      type: String,
      default: 'radio'
    },
    options: {
      type: Array,
      default: () => []
    }
  }
})
